/* eslint-disable @typescript-eslint/no-explicit-any */

type ClearNull<El extends Record<string, any>> = {
  [K in keyof El]: NonNullable<El[K]>
}

export const clearNullish = <El extends Record<string, any>>(
  el: El,
  falsy = false
): ClearNull<El> => {
  const nonNull = { ...el }

  Object.keys(el).forEach((k: keyof El) => {
    if (el[k] === null || (falsy && !el[k])) {
      delete nonNull[k]
    }
  })

  return nonNull
}
